<template>
  <div :class="$t('FCB.fcb-class-name')">
    <page-navigate></page-navigate>

    <div class="fcb-1">
      <div class="container">
        <img class="fcb-logo" :src="require(`../assets/image/FCB/fcb-logo-${$t('CFooters.bannerLang')}.png`)" alt="">


        <p class="fcb-desc scroll-fade-up">{{ $t('FCB.fcb-page1.text2') }}</p>

        <p class="fcb-desc scroll-fade-up" v-if="$t('FCB.fcb-page1.text3')">
          {{ $t('FCB.fcb-page1.text3') }}
        </p>
      </div>
    </div>

    <div class="fcb-2">
      <div class="container">
        <video muted="muted" autoplay="autoplay" loop="loop" playsinline poster="../assets/image/FCB/FCB-2.jpg"
          class="about-video_page-screen-0__video">
          <source src="../assets/image/FCB/FCB-Preview.mp4" type="video/mp4">
        </video>
        <p class="fcb-title scroll-fade-up">{{ $t('FCB.fcb-page2.text1') }}</p>
        <img class="fcb-star" src="../assets/image/FCB/FCB-star.svg" alt="">
        <p class="fcb-desc scroll-fade-up" v-html="$t('FCB.fcb-page2.text2')">
        </p>
        <a href="/FCB-video.mp4" target="_blank">
          {{ $t('FCB.video-btn') }}
        </a>
      </div>
    </div>

    <div class="fcb-3">
      <div class="container">
        <p class="fcb-title scroll-fade-up">{{ $t('FCB.fcb-page3.text1') }}</p>
        <img class="fcb-star" src="../assets/image/FCB/FCB-star.svg" alt="">
        <p class="fcb-desc scroll-fade-up">{{ $t('FCB.fcb-page3.text2') }}</p>
        <p class="fcb-desc scroll-fade-up">{{ $t('FCB.fcb-page3.text3') }}</p>
        <p class="fcb-desc scroll-fade-up">{{ $t('FCB.fcb-page3.text4') }}
        </p>
      </div>
    </div>

    <div class="fcb-4">
      <div class="container">
        <p class="fcb-title scroll-fade-up">{{ $t('FCB.fcb-page4.text1') }}</p>
        <img class="fcb-star" src="../assets/image/FCB/FCB-star.svg" alt="">
        <p class="fcb-desc scroll-fade-up">{{ $t('FCB.fcb-page4.text2') }}</p>
        <p class="fcb-desc scroll-fade-up">{{ $t('FCB.fcb-page4.text3') }}
        </p>
      </div>
    </div>

    <div class="fcb-5">
      <div class="container">
        <p class="fcb-title scroll-fade-up">{{ $t('FCB.fcb-page5.text1') }}</p>
        <img class="fcb-star" src="../assets/image/FCB/FCB-star.svg" alt="">
        <p class="fcb-desc scroll-fade-up">{{ $t('FCB.fcb-page5.text2') }}</p>
        <p class="fcb-desc scroll-fade-up">{{ $t('FCB.fcb-page5.text3') }}
        </p>
      </div>
    </div>

    <div class="fcb-6">
      <div class="container">
        <p class="fcb-title scroll-fade-up">{{ $t('FCB.fcb-page6.text1') }}</p>
        <img class="fcb-star" src="../assets/image/FCB/FCB-star.svg" alt="">
        <p class="fcb-desc scroll-fade-up">{{ $t('FCB.fcb-page6.text2') }}</p>
        <p class="fcb-desc scroll-fade-up">{{ $t('FCB.fcb-page6.text3') }}</p>
        <p class="fcb-desc scroll-fade-up">{{ $t('FCB.fcb-page6.text4') }}
        </p>
      </div>
    </div>

    <div class="fcb-7 section7">
      <div class="container" style="position: relative;">
        <p class="fcb-title scroll-fade-up">{{ $t('FCB.fcb-page7.text1') }}</p>
        <img class="fcb-star" src="../assets/image/FCB/FCB-star.svg" alt="">
      </div>
      <div class="section5NewList over-hidden pc scroll-fade-up">
        <div class="news-list flex">
          <div class="news-li " v-for="(item, index) in newData" :key="index" v-if="item.tips != ''"
            @click="jumPage(item)">
            <div class="thumbnail">
              <a @click="jumPage(item)">
                <img :src="item.logo" :alt="item.tit">
              </a>
              <a href="">
                <h3 class="body-16_medium">{{ item.tit }}</h3>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="mobile news-listm scroll-fade-up">
        <div class="news-li" v-for="(item, index) in newData" :key="index" v-if="item.tips != ''"
          @click="jumPage(item)">
          <a @click="jumPage(item)">
            >
            <div class="left">
              <h3 class="md-body-14_medium">{{ item.tit }}</h3>
              <h4 class="md-footnote-regular_12">{{ item.time }}</h4>
            </div>
            <img :alt="item.tit" :src="item.logo"/>
          </a>

        </div>
      </div>
      <div>
            <a
              href="https://www.ebc.com/zh-cn/jinrong/ebc-official/ "
              target="_blank"
              class="bottomBtn scroll-fade-up"
            >
                <span class="word15">了解更多</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  class="pc"
                >
                  <path
                    d="M7.07485 5.04079C6.82194 4.80595 6.80713 4.41035 7.04189 4.1574C7.27673 3.9045 7.67232 3.88969 7.92527 4.12445L13.7586 9.54111C13.886 9.65937 13.9584 9.82549 13.9584 9.99928C13.9584 10.1731 13.886 10.3392 13.7586 10.4575L7.92527 15.8741L7.87644 15.9152C7.62372 16.1062 7.26209 16.0783 7.04189 15.8412C6.82181 15.604 6.82096 15.2416 7.03009 15.0038L7.07485 14.9578L12.4146 9.99928L7.07485 5.04079Z"
                    fill="white"
                  />
                </svg>
            </a>
          </div>
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
import seamscroll from "../assets/js/seamless.min.js";
import fadeAnimate from "../mixins/fadeAnimate.js";
import {
  mapState,
} from 'vuex'
export default {
  mixins: [fadeAnimate],
  head() {
    return {
      title: this.title1,
      meta: [ // set meta
        {
          name: 'keyWords',
          content: 'EBC,EBC平台,EBC官网,EBC金融官网,EBC开户,EBC金融'
        },
        {
          name: 'description',
          content: 'EBC Financial GroupはFCバルセロナと公式FXパートナーとして提携し、様々なサービスを提供いたします。'
        }
      ]
    }
  },
  data() {
    return {
      infoData: "",
      newData: "",
      pagIndex: 0,
      num: 3,
      newsdisplay: "none"
    }
  },
  computed: {
    ...mapState({
      lang: state => state.Lan,
    })
  },
  destroyed() {
    window.removeEventListener('scroll', this.scroll, false)
  },
  created() {
    $('html,body').animate({
      scrollTop: 0
    }, 0);
  },
  mounted() {
    window.addEventListener('scroll', this.scroll)
    document.documentElement.setAttribute("data-theme", "dark");
    this.getNewData()
    
  },
  methods: {
    getNewData() {
      console.log(11)
      let parms;
      if (this.lang === 'zh_CN') {
        parms = 'zh_CN'
      } else {
        parms = 'en_US'
      }
      this.$http("/ebc/api/getLearnCategory/run", {
        lang: parms,
      }).then(res => {
        this.newData = res.data.data[0].info
        setTimeout(() => {
          seamscroll.init({
            dom: document.getElementsByClassName("news-list")[0],
            direction: 2,
            step: 0.6,
            hoverStep: 0.3,
            hoverStop: false,
          });
            },100)
      })
    },
    jumPage(idx) {
      this.$router.push({
        name: 'LearningCenterInfo',
        query: {
          id: idx.id,
          lang: this.$t("common.requestLang")//this.$store.state.Lan
        }
      })
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  }
}

</script>

<style>
@charset "UTF-8";

.c-footer .fp-overflow {
  display: unset !important;
}


.fcb-1 {
  background: url(../assets/image/FCB/FCB-1.jpg) 100% / auto 100% no-repeat;
  margin-top: 0px;
  text-align: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  padding-top: 240px;
}

.fcb-1 .fcb-logo {
  margin-bottom: 24px;
  width: 35%;
}

.fcb-1 .fcb-1-title {
  color: #FFF;
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  line-height: 150%;
  margin-bottom: 50px;
}

.fcb-1 .fcb-1-title br {
  display: none;
}




.fcb-2 {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  text-align: center;
}

.fcb-2 video {
  width: 100%;
  height:100%;
  object-fit: cover;
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}

.fcb-2 a {
  border-radius: var(--ebc-corner-radius-full);
  border: 1px solid var(--ebc-text-primary_white);
  font-size: 16px;
  font-weight: 500;
  padding: 15px 24px;
  color: var(--ebc-text-primary_white);
  margin-top: 12px;
  display: inline-block;
}

.fcb-2 a:hover {
  background: var(--ebc-basecolor-white-12);
}

.fcb-title {
  color: #FFBC3A;
  text-align: center;
  font-size: 80px;
  font-style: normal;
  font-weight: 700;
  line-height: 88px;
  letter-spacing: 1.28px;
  width: 1200rem;
  margin: 0 auto;
}

.fcb-star {
  margin-top: 24px;
  margin-bottom: 24px;
}

.fcb-2 .fcb-desc {
  line-height: 48px;
}

.fcb-desc {
  color: #FFF;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  width: 1200rem;
  margin: 0 auto 15px;
  opacity: 0.9;
}

.fcb-desc span {
  font-weight: 900;
}


.fcb-3 {
  background: url(../assets/image/FCB/FCB-3.jpg) 100% / auto 100% no-repeat;
  margin-top: 0px;
  text-align: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.fcb-4 {
  background: url(../assets/image/FCB/FCB-4.jpg?t=1712562558) 100% / auto 100% no-repeat;
  margin-top: 0px;
  text-align: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.fcb-4 .fcb-hover-pc {
  margin-top: 90px;
  width: 100%;
}

.fcb-4 .fcb-hover-m {
  display: none;
}



.fcb-5 {
  background: url(../assets/image/FCB/FCB-5.jpg) 100% / auto 100% no-repeat;
  margin-top: 0px;
  text-align: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.fcb-6 {
  background: url(../assets/image/FCB/FCB-6.jpg?t=1712562557) 100% / auto 100% no-repeat;
  margin-top: 0px;
  text-align: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.fcb-7 {
  background: url(../assets/image/FCB/FCB-7.jpg) 100% / auto 100% no-repeat;
  margin-top: 0px;
  text-align: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  /* height: 105vh; */
  padding: 180px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.fcb-7 .fcb-title {
  width: 100%;
}

.fcb-image-list {
  width: 1000px;
  overflow: hidden;
  margin: 10px auto 0;
}

.fcb-image-list img {
  border-radius: 6px;
}

.fcb-image-list .swiper-slide-shadow-left,
.fcb-image-list .swiper-slide-shadow-right {
  display: none !important;
}




.fcb-register {
  width: max-content;
  padding: 14px 40px 14px 60px;
  border-radius: 100px;
  background: var(--Linear, linear-gradient(90deg, #861A18 0%, #19172B 100%));
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.35);
  position: relative;
  position: absolute;
  bottom: 70px;
  left: 50%;
  transform: translateX(-50%);
}

.fcb-register img {
  width: 13px;
  position: absolute;
  left: 30px;
  top: 15px;
}

.fcb-register p {
  color: #FFBC3A;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  text-transform: capitalize;
  float: left;
}

.fcb-register span {
  width: 1px;
  height: 18px;
  background: rgba(255, 255, 255, 0.40);
  display: block;
  float: left;
  margin: 0 20px;
}

.fcb-register a {
  color: #fff;
  opacity: 0.9;
  font-size: 16px;
}


.fcb-7 .container {
  width: 1100px;
}

.fcb-7 .swiper-wrapper {
  padding: 0;
}

.fcb-7 .swiper-button-prev {
  left: -52px;
  background-image: url(../assets/image/FCB/fcb-prev.svg);
  width: 22px;
  height: 44px;
  background-size: 90%;
  background-repeat: no-repeat;
  top: 62%;
}

.fcb-7 .swiper-button-next {
  right: -52px;
  background-image: url(../assets/image/FCB/fcb-next.svg);
  width: 22px;
  height: 44px;
  background-size: 90%;
  background-repeat: no-repeat;
  top: 62%;
}

.swiper-button-next:after,
.swiper-button-prev:after {
  content: "";
}

.cn-fcb-box .fcb-1 .fcb-desc {
  width: 100%;
}

.cn-fcb-box .fcb-1 {
  padding-top: 430px;
}



@media(max-width:1700px) {
  .fcb-register {
    display: none;
  }

  .fcb-1 .fcb-1-title {
    margin-bottom: 40px;
  }

  .fcb-1 .fcb-logo {
    width: 30%;
  }
}

@media(max-width:1700px) {
  .fcb-register {
    display: none;
  }

  .fcb-1 .fcb-1-title {
    margin-bottom: 40px;
  }

  .fcb-1 .fcb-logo {
    width: 30%;
  }

  .fcb-2 {
    height: 80vh;
  }
}

@media(max-width:1600px) {
  .fcb-2 {
    height: 70vh;
  }

}

@media(max-width:1500px) {
  .fcb-2 {
    height: auto;
    padding: 110px 0;
  }
}

@media(max-width:1400px) {
  .fcb-1 .fcb-logo {
    width: 34%;
    margin-bottom: 16px;
  }

  .fcb-1 .fcb-1-title {
    font-size: 18px;
  }

  .fcb-register {
    display: none;
  }

  .fcb-title {
    font-size: 40px;
    line-height: 48px;
  }

  .fcb-desc {
    font-size: 16px;
  }

  .fcb-image-list {
    width: 750px;
  }

  .cn-fcb-box .fcb-title {
    font-size: 40px;
    line-height: 48px;
  }

  .fcb-7 {
    height: 140vh;
    display: block;
    padding-top: 80px;
  }

  .fcb-4 .fcb-hover-pc {
    margin-top: 40px;
    width: 100%;
  }
}

.section7 .news-list {
  transition: transform;
}

.section7 .news-list .news-li {
  margin-inline: 16px;
}

.section7 .news-list img {
  width: 360px;
  min-width: 360px;
  height: 240px;
  margin-bottom: 8rem;
  border-radius: var(--ebc-corner-radius-rc04);
  cursor: pointer;
}

.section7 .news-list h3 {
  padding-inline: 4px;
  color: var(--ebc-text-primary_white);
  margin: 0;
  cursor: pointer;
  text-align: left;
}

.section7 .bottomBtn {
  width: fit-content;
  margin-inline: auto;
  display: block;
  min-width: 160px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  font-size: 16px;
  font-weight: 500;
  line-height: 28px;
  color: #fff;
  background: var(--ebc-basecolor-active-500);
  border-radius: var(--ebc-corner-radius-full);
  margin-top: 48px;
}

.section7 .bottomBtn:hover {
  background: var(--ebc-basecolor-active-400);
}

.section7 .bottomBtn svg {
  margin-left: 4px;
}

@media(max-width:995px) {
  .news-li a{
      display: flex;
    }
  .section7 .news-listm {
    width: 686rem;
    margin-inline: auto;
  }

  .section7 .news-listm img {
    width: 120px;
    flex: 0 0 120px;
    height: 80px;
    border-radius: var(--ebc-corner-radius-rc16);
  }

  .section7 .news-listm h3 {
    margin: 0;
    padding: 0;
    text-align: left !important;
    color: var(--ebc-text-primary_white);
  }

  .section7 .news-listm h4 {
    color: var(--ebc-text-secondary_white);
    text-align: left;
  }

  .section7 .news-listm .news-li {
    padding: 16px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  }

  .section7 .news-listm .news-li .left {
    padding: 6px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .section7 .news-listm .news-li a {
    justify-content: space-between;
    align-items: center;
    gap: 16px;
  }

  .section7 .news-listm .news-li:nth-child(n + 5) {
    display: none;
  }

  .section7 .bottomBtn {
    font-size: 14px;
    line-height: 22px;
    height: 40px;
    margin-top: 24px;
  }

  .nav-link {
    padding: 0;
  }

  #page-navigate.darkMode {
    background: transparent !important;
  }

  #page-navigate.darkMode.whiteBg {
    background: #000 !important;
  }

  .fcb-1,
  .fcb-2,
  .fcb-3,
  .fcb-4,
  .fcb-5,
  .fcb-6,
  .fcb-7 {
    padding-inline: 16px;
  }
 .fcb-1{
      background: url(../assets/image/FCB/FCB-1-m.jpg) 100% / auto 100% no-repeat;
      background-position:center;
    }
  .en-fcb-box,
  .cn-fcb-box {
    margin-top: -44px;
  }

  .fcb-image-list {
    width: 100%;
  }

  .fcb-1 {
    padding-top: 60px;
  }

  .fcb-1 .fcb-logo {
    width: 76%;
  }

  .fcb-1 .fcb-1-title {
    font-size: 16px;
  }

  .fcb-title {
    font-size: 40px;
    width: 90%;
  }

  .fcb-2 video {
    position: absolute;
    left: 50%;
    top: 0;
    width: 1400px;
    min-width: 0;
    transform: translateX(-50%);
  }

  .fcb-2 {
    overflow: hidden;
    height: 85vh;
  }

  .fcb-desc {
    width: 100%;
    line-height: 28px;
  }

  .fcb-7 {
    height: auto;
    padding: 50px 0;
  }

  .fcb-7 .fcb-title {
    width: 90%;
  }

  .cn-fcb-box .fcb-title {
    font-size: 40px;
    line-height: 48px;
    width: 92%;
  }

  .cn-fcb-box .fcb-desc {
    line-height: 28px;
  }

  .fcb-image-list img {
    width: 100%;
  }

  .fcb-4 .fcb-hover-pc {
    display: none;
  }

  .fcb-4 .fcb-hover-m {
    display: inline-block;
    width: 100%;
    margin-top: 30px;
  }

  .fcb-4 {
    height: 100vh;
  }

  .fcb-7 .container {
    width: 100%;
    overflow: hidden;
  }

  .fcb-register {
    bottom: 40px;
    display: none;
  }

  .fcb-7 .fcb-news-list {
    padding-left: 4%;
  }

  /*.fcb-register p{
      font-size: 14px;
      line-height: 18px;
    }
    .fcb-register a{
      font-size: 14px;
      line-height: 18px;
    }
    .fcb-register span{

    }
    .fcb-register img{
      top: 16px;
    }*/

  .fcb-1 .fcb-desc {
    width: 100%;
    line-height: 24px;
    font-size: 16px;
  }

  .fcb-7 .news-li h3 a {
    font-size: 18px;
  }

  .fcb-7 .news-li p {
    font-size: 14px;
  }
}
</style>
